module.exports = __webpack_public_path__ + "img/empty_comments.08e84b11.svg";